import { AfterViewInit, Component, computed, ElementRef, Input, OnChanges, OnDestroy, OnInit, Signal, signal, SimpleChanges, ViewChild, WritableSignal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { filter, map, Subject, Subscription, takeUntil } from 'rxjs';
import { TypeFilter } from 'src/app/models/enums/TypeFilter.enum';
import { FieldConfig, Terms } from 'src/app/models/types/Filters.type';
import { FiltersService } from 'src/app/services/filters.service';
import { Collapse } from 'bootstrap';

@Component({
  selector: 'app-multi-select',
  imports: [ReactiveFormsModule, TranslateModule],
  templateUrl: './multi-select.component.html',
  styleUrl: './multi-select.component.scss'
})
export class MultiSelectComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  @Input('config') config!: FieldConfig;

  @ViewChild('accordion') accordion!: ElementRef;
  public collapseInstance!: Collapse;

  private formControl!: FormControl;

  public valuesCounter: WritableSignal<number> = signal(0);

  public collapsed: WritableSignal<boolean> = signal(true);

  private readonly _destroying$ = new Subject<void>();

  public get TypeFilter() {
    return TypeFilter;
  }

  public get isTCurrencyType(): boolean {
    return this.config.type === TypeFilter.CURRENCY;
  }

  public get showDeselectAllOption(): boolean {
    //Mostro l'option per la deselezione dei valori solo se
    //C'è almeno una option e se sono state selezionate almeno due options
    return !!this.config.options?.length && this.formControl.value.length > 1;
  }

  constructor(
    private readonly filtersService: FiltersService
  ) { }

  ngOnInit(): void {
    this.formControl = this.filtersService.getFormControl(this.config.field);
    this.valuesCounter.set(this.formControl.value.length);

    this.filtersService.submit$
      .pipe(
        //Filtro solo il campo che corrisponde al config.field
        map(values => values.find(item => item.field === this.config.field)),
        takeUntil(this._destroying$)
      )
      .subscribe(field => {
        //Tengo traccia dei valori che sono stati submittati per mostrare o meno il counter
        this.valuesCounter.set(field ? field.values.length : 0);
        this.hideCollapse();
      });

    this.filtersService.reset$
      .pipe(
        takeUntil(this._destroying$)
      ).subscribe(val => {
        this.handleDeselect();
        this.valuesCounter.set(0);
        this.hideCollapse();
      });
  }

  ngAfterViewInit() {
    this.collapseInstance = new Collapse(this.accordion.nativeElement, { toggle: false });
  }

  ngOnChanges(changes: SimpleChanges): void { }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  public getAccordionId(withHash?: boolean): string {
    return `${withHash ? '#' : ''}${this.config.field}-accordion`;
  }

  public getCollapsenId(withHash?: boolean): string {
    return `${withHash ? '#' : ''}${this.config.field}-collapse`;
  }

  public getOptionId(index: number): string {
    return `${this.config.field}-${index}-option`;
  }

  public handleChange(idTerm: number | string) {
    const currentValue: any[] = this.formControl.value;
    if (currentValue.includes(idTerm)) {
      // Rimuove il valore se già presente
      this.formControl.setValue(currentValue.filter((val: any) => val !== idTerm));
    } else {
      // Aggiunge il valore se non presente
      this.formControl.setValue([...currentValue, idTerm]);
    }
  }

  public isChecked(idTerm: number | string): boolean {
    return this.formControl.value.includes(idTerm);
  }

  public handleDeselect() {
    this.formControl.reset();
    this.formControl.setValue([]);
  }

  public hideCollapse() {
    if (this.collapseInstance) {
      this.collapseInstance.hide();
    }
  }

  public toggle() {
    this.collapseInstance.toggle();
    this.collapsed.set(!this.collapsed());
  }

}
